import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=e27c8caa&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=ts"
export * from "./TemplateSelector.vue?vue&type=script&lang=ts"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=e27c8caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27c8caa",
  null
  
)

export default component.exports